<template>
	<Modal v-model="modal3.ifShow" :title="modal3.Title" width="30%" :mask-closable="false" :closable="false">
		<!--会员添加修改-->
		<Form label-position="right" :rules="ruleInline3" v-if="modal3.type=='add'||modal3.type=='up'"
			ref="RechangeForGroupMemberForm" :model="RechangeForGroupMemberInfo" :label-width="110">
			<Row :gutter="24">
				<Col span=24>
				<FormItem label="会员ID:" prop="GroupId">
					<Input :disabled="modal3.canInput" v-model="RechangeForGroupMemberInfo.GroupId"
						placeholder="输入会员ID"></Input>
				</FormItem>
				</Col>
			</Row>
			<Row :gutter="24">
				<Col span=12>
				<FormItem label="充值金额(元):" prop="RechargeAccount">
					<Input v-model="RechangeForGroupMemberInfo.RechargeAccount" placeholder="充值金额" number></Input>
				</FormItem>
				</Col>
				<Col span=12>
				<FormItem label="赠送金额(元)" prop="GivenAccount">
					<Input v-model="RechangeForGroupMemberInfo.GivenAccount" placeholder="赠送金额" number></Input>
				</FormItem>
				</Col>
			</Row>
		</Form>
		<div v-if="modal3.type=='add'" slot="footer">
			<Button type="warning" size="large" @click="modalOk3('cancle')">取消</Button>
			<Button type="success" size="large" @click="modalOk3('add')">充值</Button>
		</div>
	</Modal>
</template>

<script>
	import webapi from '../../../../webapi';
	export default {
		data() {
			return {
				//充值model
				RechangeForGroupMemberInfo: {
					GroupId: '',
					RechargeAccount: 0,
					GivenAccount: 0,
				},
				//充值model 规则
				ruleInline3: {
					RechargeAccount: [{
							required: true,
							message: '请输入价格',
							trigger: 'blur',
							type: 'number',
						},
						// {
						// 	validator: usernameV,
						// 	trigger: 'blur'
						// }
					],
					GivenAccount: [{
						required: true,
						message: '请输入价格',
						trigger: 'blur',
						type: 'number',
					}]
				},
				//model3 充值
				modal3: {
					Title: "集团会员充值",
					type: "add",
					ifShow: false,
					canInput: true
				},
			}
		},
		methods: {
			//打开集团会员充值
			openRechangeForGroupMember: function(GroupId) {
				this.modal3.Title = "集团充值";
				this.modal3.type = "add";
				this.$refs.RechangeForGroupMemberForm.resetFields()
				this.RechangeForGroupMemberInfo.GroupId = GroupId
				this.modal3.ifShow = true
			},
			//model3操作
			modalOk3: function(type) {
				const _this = this
				switch (type) {
					case 'cancle':
						_this.modal3.ifShow = false
						break;
					case 'add':
						_this.modal3.ifShow = true
						_this.RechangeForGroupMember();
						break;
					default:
						break;
				}
			},

			//集团会员充值
			RechangeForGroupMember: function() {
				const _this = this;
				let parms = _this.RechangeForGroupMemberInfo;
				this.$refs.RechangeForGroupMemberForm.validate((valid) => {
					if (valid) {
						_this.$axios.post(webapi.base_api_url + "/Member/RechangeForGroupMember", parms, {})
							.then(res => {
								console.log("集团会员充值")
								console.log(res.data)
								if (res.data.Code == 0) {
									this.$Message.success('会员充值成功');
									_this.$emit("handleSubmit")
									_this.modalOk3("cancle")
								} else {
									this.$Message.error('会员充值失败');
									this.$Message.error(res.data.Msg + "---" + res.data.Data);
								}
							})
					}
				})
			},
		}
	}
</script>

<style>
</style>
